import api from '../auth';
const slug = 'api/vnos/';

const VnoService = () => {
    const getVnos = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getVnosLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getVno = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteVno = (id) => {
        return api
            .delete(slug + `vno/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createVno = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateVno = (id, data) => {
        return api.put(slug + `vno/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyVno = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    return {
        getVnos,
        getVnosLazy,
        getVno,
        deleteVno,
        createVno,
        updateVno,
        getOptions,
        copyVno
    };
};

export default VnoService;
